export var FormCssClass;
(function (FormCssClass) {
    FormCssClass["Base"] = "iress-form";
    FormCssClass["Form"] = "iress-form__form";
    FormCssClass["Header"] = "iress-form__header";
    FormCssClass["Footer"] = "iress-form__footer";
    FormCssClass["Error"] = "iress-form--error";
    FormCssClass["ErrorSummary"] = "iress-form__error-summary";
    FormCssClass["ErrorSummaryList"] = "iress-form__error-summary-list";
    FormCssClass["Alert"] = "iress-form__alert";
})(FormCssClass || (FormCssClass = {}));
export var FormDefaultText;
(function (FormDefaultText) {
    FormDefaultText["BadInput"] = "{{fieldName}} value is not valid";
    FormDefaultText["PatternMismatch"] = "{{fieldName}} is not in a valid format";
    FormDefaultText["RangeOverflow"] = "{{fieldName}} must be {{attrValue}} or lower";
    FormDefaultText["RangeUnderflow"] = "{{fieldName}} must be {{attrValue}} or more";
    FormDefaultText["TooLong"] = "{{fieldName}} is too long. Must not exceed {{attrValue}} characters";
    FormDefaultText["TooShort"] = "{{fieldName}} is too short. Must be at least {{attrValue}} characters long";
    FormDefaultText["TypeMismatch"] = "{{fieldName}} is not in a valid format";
    FormDefaultText["StepMismatch"] = "{{fieldName}} value is not valid";
    FormDefaultText["ValueMissing"] = "{{fieldName}} is a required field";
    FormDefaultText["ErrorSummaryHeading"] = "There was a problem submitting this form";
})(FormDefaultText || (FormDefaultText = {}));
export var FormSlot;
(function (FormSlot) {
    FormSlot["Footer"] = "footer";
    FormSlot["Header"] = "header";
    FormSlot["Alert"] = "alert";
})(FormSlot || (FormSlot = {}));
//# sourceMappingURL=form.types.js.map